import { GAD_RS_LOAD, GAD_RS_UNLOAD } from "../../actions/Constants";
const INITIAL_STATE = { all: [] };

export default function gadRs(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GAD_RS_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : [],
      };
    case GAD_RS_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
